import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppBar, Box, Container, CssBaseline, Toolbar } from '@mui/material';
import Header from './Header';
import Footer from 'ui-component/Footer';
export default function MinimalLayout() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    const scroll = () => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
      if (attempts++ < 25) timer = window.setTimeout(scroll, 100);
    };
    let timer = window.setTimeout(scroll, 50);
    return () => clearTimeout(timer);
  }, [pathname, hash]);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{ bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Container maxWidth={false} sx={{ maxWidth: 1256, px: { xs: 2.5, sm: '28px' } }}>
          <Toolbar disableGutters sx={{ height: 82, gap: 2 }}>
            <Header />
          </Toolbar>
        </Container>
      </AppBar>
      <Box component="main" sx={{ flex: '1 1 auto', pt: '82px', minWidth: 0 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}
